export default {
feedback: {
  title: "प्रतिक्रिया",
  placeholder: "संदेश लिखें ({ contentLen }/1000 अक्षर)",
  error: "यह एक त्रुटि संदेश है",
  uploadLimit: "छवि और वीडियो अपलोड सीमा",
  send: "भेजें",
  tipTitle: "हमारे अनुभव को बेहतर बनाने में मदद करें",
  desc1: "आप कोई भी प्रश्न भेज सकते हैं, और यदि स्वीकार किया गया, तो आपको एक सरप्राइज उपहार मिलेगा।",
  desc2: "यदि वेबसाइट से भेजना संभव नहीं है, तो आप हमें ईमेल भी कर सकते हैं।"
}
};
